const {wrapEntityApi} = require('../utils/wrap-api')
// REFACTOR: let's rename data-access = data-adapters across the board.
const { rawMethods, StockPouchDBAdapter, StockRestAdapter, StockPGAdapter, StockTransactionsPgAdapter } = require('./data-access')
const getWarehouseBatchData = require('../stock-warehouse-get-batch-data')
const nhlmisRestSubmit = require('./data-access/nhlmis-rest-submit')
const nhlmisRestGet = require('./data-access/nhlmis-rest-get')
const { prepareFacilityImportTemplate } = require('./facility-stock/get-facility-import-data')
const { getFacilityStock } = require('./facility-stock/get-facility-stock-data')
const { createFacilityStockReport } = require('./facility-stock/create-facility-report')
const getNonSellableBalance = require('../stock-get-non-sellable-balance')

const TransactionApi = require('./transactions')

// Not an EntityApi, stock is a cross entity concept
class StockApi {
  constructor (state, mainApi, restAdapter, logger, pgConnection, agaveAdapter) {
    // REFACTOR: this could be in EntityApi and subclasses use super(MyPouchDBAdaper, StockRestAdapter)
    let adapter
    const { user } = state
    adapter = new StockPouchDBAdapter(user, restAdapter)
    this.adapter = adapter
    this.mainApi = mainApi
    this.agaveAdapter = agaveAdapter
    // TODO: remove this when all raw methods have been ported
    const apiMethods = wrapEntityApi(rawMethods, state)
    Object.assign(this, apiMethods)

    this.restAdapter = new StockRestAdapter(restAdapter)
    if (pgConnection) {
      const username = user.name
      this.pgAdapter = new StockPGAdapter({ pgConnection, username, logger })
      this.stockTransactions = new StockTransactionsPgAdapter(pgConnection, username, logger)
    }

    this.transactions = new TransactionApi(state, mainApi, logger)
  }

  getWarehouseProductBatchData (funderId, programId) {
    return getWarehouseBatchData(this.mainApi.state, {
      batchApi: this.mainApi.batch,
      funderApi: this.mainApi.funders,
      configurationApi: this.mainApi.configuration,
      locationApi: this.mainApi.location,
      funderId,
      programId
    })
  }

  getWarehouseStockImportFile (funder, program, opts = {}) {
    return this.agaveAdapter.getBlob('stock/warehouse-import', {
      funder,
      program,
      ...opts
    })
  }

  uploadWarehouseStock (formData) {
    return this.agaveAdapter.create('stock/warehouse-upload', formData)
  }

  getWarehouseStockData (locationId, serviceId) {
    return this.agaveAdapter.getBlob('stock/warehouse-stock', {
      locationId,
      serviceId
    })
  }

  nhlmisRestGet ({ locationId, serviceId }) {
    return nhlmisRestGet(this.mainApi, { locationId, serviceId })
  }

  getFacilityStockImportFile (locationId, serviceId) {
    return this.agaveAdapter.getBlob('stock/facility-import-csv', {
      locationId,
      serviceId
    })
  }

  getFacilityImportTemplate (serviceId) {
    return prepareFacilityImportTemplate(this.mainApi, { serviceId })
  }

  getFacilityStockData (locationId, programId, serviceId) {
    return this.agaveAdapter.getBlob('stock/facility-stock', {
      locationId,
      programId,
      serviceId
    })
  }

  async getFacilityData (locationId, programId, serviceId) {
    return getFacilityStock(this.mainApi, {
      locationId,
      programId,
      serviceId
    })
  }

  uploadFacilityStock (locationId, programId, serviceId, formData) {
    const params = `locationId=${locationId}&programId=${programId}&serviceId=${serviceId}`
    return this.agaveAdapter.create(`stock/facility-stock-upload?${params}`, formData)
  }

  createFacilityStockReport ({ locationId, programId, serviceId, stockData }) {
    return createFacilityStockReport(this.mainApi, {
      locationId,
      programId,
      serviceId,
      stockData
    })
  }

  getNonSellableBalance ({ locationId, date } = {}) {
    if (!this.stockTransactions) {
      throw new Error('getNonSellableBalance: pg connection is required')
    }
    return getNonSellableBalance({
      pgConnection: this.stockTransactions.pgConnection,
      locationId,
      date
    })
  }
}

Object.assign(StockApi.prototype, {nhlmisRestSubmit})

// TODO: remove this when all raw methods have been ported
module.exports = rawMethods
module.exports.StockApi = StockApi
